<template>
  <div>
    <div class="channel" v-if="isLimit">
      <div class="search fixed_horizo_center">
        <div class="flex-center margin-bot">
          <van-search class="flex1" v-model="customerName" placeholder="搜索客户名称" @clear="clearCustomer" />
          <span :span="4" class="search-text" @click="searchCustomer">搜索</span>
        </div>
        <van-dropdown-menu active-color="#277FFF">
          <van-dropdown-item v-model="status" :options="statusOption" />

          <van-dropdown-item :title="tagTitle" ref="item">
            <!-- 企业标签 -->
            <div class="border-top">
              <div v-for="itwm in tagOption" :key="itwm.group_id" class="active-content">
                <p>{{ itwm.group_name }}</p>
                <div class="tag-list-dropdown">
                  <span v-for="single in itwm.tag" :key="single.id" @click="selectLabel(single)" :class="{ activetag: isInclude(selectArr, single) }">{{ single.name }}</span>
                </div>
              </div>
            </div>
            <div class="tag-btn">
              <van-button plain type="info" block round @click="onResetTag"> 重置 </van-button>
              <van-button type="info" block round @click="onConfirm"> 确认 </van-button>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
      <div class="total-title list-padding">{{ "共有" + total + "位客户" }}</div>
      <van-list v-model="loading" :finished="finished" loading-text="正在加载中..." finished-text="暂无更多内容了" @load="load_more" :immediate-check="false">
        <div v-for="(item, index) in list" :key="index + 'i'" class="item_customer">
          <div class="item">
            <div class="flex-start">
              <van-image class="avatar_user" round fit="cover" :src="item.avatar" />
              <div class="flex1 flex-center">
                <div class="title flex1">
                  <h4>{{ item.name }}</h4>
                  <p class="van-multi-ellipsis--l2">备注：{{ item.otherDescr }}</p>
                  <p>添加员工：{{ item.firstUserName }}</p>
                  <p>{{ item.firstAddTime }}</p>
                </div>
                <div class="contact-btn" @click="contractTo(item)">联系Ta</div>
              </div>
            </div>
            <div class="tag-list customer-tag-list" v-if="item.tagNames">
              <span class="tag-list-item" v-for="(value, index) in item.tagNames.split(',')" :key="index">
                {{ value }}
              </span>
            </div>
            <p class="show" @click="expandClick">
              {{ "展开全部标签(" + item.tagNames.split(",").length + ")" }}
              <van-icon name="play" />
            </p>
          </div>
        </div>
      </van-list>
    </div>
    <emptyPage :isLimit="isLimit" />
  </div>
</template>

<script>
import { Toast } from "vant";
import { getCustomerList, getTagList } from "@/server/api.js";
import { wxConfig } from "../fastReply/js/config";
import { wefunstatistics, pageLimit } from "@/utils/public";
import emptyPage from "@/components/emptyPage";

export default {
  data() {
    return {
      status: 0,
      tag: "",
      tagTitle: "全部企业标签",
      statusOption: [
        { text: "全部状态", value: 0 },
        { text: "已流失", value: 1 },
        { text: "未流失", value: 2 },
      ],
      tagOption: [],
      selectArr: [],
      list: [], //客户列表
      pageNum: 1,
      pageSize: 20,
      loading: false,
      finished: false,
      total: 0, // 总条数
      tagIds: [],
      customerName: "",
      isLimit: "",
    };
  },
  components: { emptyPage },
  created() {
    let that = this;
    pageLimit("customer:query", function (bool) {
      that.isLimit = bool;
      if (that.isLimit) {
        that.getTagList();
        that.getPosterList();
        that.relaxWxConfig();
        wefunstatistics("9", window.location.href.split("#")[0]);
      } else {
        that.isLimit = bool;
      }
    });
  },
  watch: {
    status() {
      this.list = [];
      this.pageNum = 1;
      this.getPosterList();
    },
    list: {
      handler() {
        this.$nextTick(() => {
          let customerList = document.querySelectorAll(".customer-tag-list");
          for (let x of customerList) {
            if (x.offsetHeight > 80) {
              x.classList.add("overFlow");
              x.nextElementSibling.style.display = "block";
            }
          }
        });
      },
      deep: true,
    },
  },
  methods: {
    async getTagList() {
      let params = {
        keywords: "",
      };
      const res = await getTagList(params);
      if (res.code !== "200") return Toast.fail(res.msg);
      this.tagOption = res.data.tagGroups.reverse();
    },
    async getPosterList() {
      this.loading = true;
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name: this.customerName,
        tagIds: this.tagIds,
        trackState: this.status,
      };
      const res = await getCustomerList(params);
      if (res.code !== "200") return Toast.fail(res.msg);
      // 加载状态结束
      this.loading = false;
      this.list = this.list.concat(res.data.list); //追加数据
      this.total = res.data.totalCount;
      if (res.data.list.length == 0 || res.data.list.length < this.pageSize) {
        //数据全部加载完成
        this.finished = true;
      } else {
        this.finished = false;
      }
    },

    scrollTop() {
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },

    //点击展开
    expandClick(e) {
      let element = e.target;
      element.previousElementSibling.classList.remove("overFlow");
      element.style.display = "none";
    },
    //加载更多
    load_more() {
      this.pageNum++;
      this.getPosterList();
    },
    searchCustomer() {
      this.list = [];
      this.pageNum = 1;
      this.scrollTop();
      this.getPosterList();
    },
    clearCustomer() {
      this.list = [];
      this.pageNum = 1;
      this.customerName = "";
      this.scrollTop();
      this.getPosterList();
    },
    //是否选中
    isInclude(arr, label) {
      return arr.find((item) => {
        return item.id == label.id;
      });
    },
    selectLabel(label) {
      this.chooseSelectLabel(this.selectArr, label);
    },
    //选择标签操作
    chooseSelectLabel(arr, label) {
      let index = arr.indexOf(label);
      if (index > -1) {
        arr.splice(index, 1);
      } else {
        arr.push(label);
      }
      return arr;
    },
    //确认标签按钮操作
    onConfirm() {
      this.$refs.item.toggle(false);
      this.tagIds = [];
      if (this.selectArr.length > 0) {
        for (let i of this.selectArr) {
          this.tagIds.push(i.id);
        }
      }
      this.list = [];
      this.scrollTop();
      this.pageNum = 1;
      this.getPosterList();
    },
    //重置操作
    onResetTag() {
      this.$refs.item.toggle(false);
      this.tagIds = [];
      this.list = [];
      this.selectArr = [];
      this.pageNum = 1;
      this.scrollTop();
      this.getPosterList();
    },
    async relaxWxConfig() {
      let windowurl = window.location.href.split("#")[0] || "https://xyqw.xinyuanhulian.com/list";
      await wxConfig(windowurl, ["openUserProfile"]);
    },
    //联系他按钮
    contractTo(item) {
      console.log(item);
      wx.invoke(
        "openUserProfile",
        {
          type: 2,
          userid: item.externalUserid,
        },
        function (res) {
          if (res.err_msg != "openUserProfile:ok") {
            //错误处理
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.channel {
  width: 100%;
  height: 100%;
  background: #f6f6f6;

  .van-search {
    padding: 0;

    /deep/ .van-icon-search {
      font-size: 30px;
    }

    /deep/ .van-field__control {
      font-size: 28px;
    }
  }

  .van-search__content {
    height: 80px;
    padding-left: 30px;
    border-radius: 40px;
    background-color: #f3f3f3;
  }

  .van-search .van-cell {
    align-items: center;
  }

  .van-field__left-icon {
    height: 80px;
  }

  .search-text {
    font-size: 32px;
    padding-left: 20px;
    cursor: pointer;
  }

  .search {
    padding: 20px 30px 10px;
    background: #fff;
    position: fixed;
    width: 100%;
    left: 0;
    z-index: 100;

    .margin-bot {
      margin-bottom: 16px;
    }

    .van-dropdown-menu {
      /deep/.van-overlay {
        // left: 0 !important;
        // transform: none !important;
      }
      /deep/ .van-dropdown-item__option {
        line-height: 60px;

        .van-cell__title {
          font-size: 28px;

          .van-ellipsis {
            overflow: auto;
          }
        }

        .van-icon-success {
          font-size: 28px;
        }
      }

      /deep/ .tag-list-dropdown {
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        span {
          border: 1px solid #d8d8d8;
          background-color: #ffffff;
          padding: 7px 19px;
          color: #333333;
          border-radius: 8px;
          margin: 0 18px 18px 0;
          font-size: 22px;
        }

        .activetag {
          color: #277fff;
          border: 1px solid #a5caff;
          background: #e0edff;
        }
      }
    }

    /deep/ .van-dropdown-menu__bar {
      box-shadow: none;
      //padding-top: 20px;
      height: 70px;
      .van-dropdown-menu__title {
        font-size: 28px;
        height: 70px;
        line-height: 70px;
        &::after {
          border: 7px solid;
          border-color: transparent transparent #dcdee0 #dcdee0;
          right: -14px;
          margin-top: -9px;
        }
      }
    }
  }
  .total-title {
    padding: 24px 30px;
    color: #999999;
    font-size: 26px;
    // margin-top: 196px;
  }
  .list-padding {
    padding-top: 117px;
  }
  .van-list {
    padding: 0 30px;
  }
  .item_customer {
    box-sizing: border-box;
    overflow: hidden;
    padding: 23px 20px;
    background: #fff;
    border-radius: 14px;
    margin-bottom: 20px;

    .tag-list {
      margin-top: 30px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      span {
        background-color: rgba(39, 127, 255, 0.2);
        line-height: 46px;
        padding: 0 19px;
        color: #277fff;
        border-radius: 8px;
        margin: 0 18px 18px 0;
        font-size: 22px;
      }
    }

    .customer-tag-list {
      overflow: hidden;
      height: auto;
      transition: all 0.4s linear;
      padding-left: 8px;
    }

    .overFlow {
      height: 110px;
    }

    .van-image {
      width: 132px;
      height: 132px;
      flex-shrink: 0;
      & + div {
        width: 0;
      }
    }

    .title {
      font-size: 24px;
      padding-left: 16px;

      h4 {
        font-size: 32px;
        margin-top: -3px;
      }

      p {
        color: #666666;
        margin-bottom: 6px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .contact-btn {
      width: 136px;
      line-height: 54px;
      font-size: 24px;
      margin-left: 18px;
      border-radius: 27px;
      color: #ffffff;
      background-color: #277fff;
      text-align: center;
    }

    .ellipsis-text {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .show {
      color: #999999;
      text-align: center;
      font-size: 22px;
      cursor: pointer;
      margin-top: 8px;
      display: none;
    }

    .van-icon-play {
      font-size: 20px;
      position: relative;
      top: -3px;
      transform: rotate(90deg);
    }
  }

  .van-multi-ellipsis--l2 {
    -webkit-line-clamp: 1;
  }

  .tag-btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 28px 0;
    border-top: solid 1px #f4f4f4;
    .van-button {
      width: 30%;
      min-width: 110px;
      height: 40px;
      font-size: 18px;
    }
  }

  .van-tag {
    font-size: 22px;
    padding: 7px 20px;
    background: #f3f3f3;
    color: #999999;
    border-radius: 8px;
    margin: 0px 20px 20px 0;
    cursor: pointer;
  }

  .border-top {
    height: 500px;
    padding-bottom: 42px;
    overflow-y: auto;
    border-top: solid 1px #f4f4f4;
    margin-top: 6px;
  }

  .active-content {
    padding: 0 60px 0;

    p {
      font-size: 26px;
      margin-top: 30px;
      margin-bottom: 14px;
      font-weight: 600;
    }
  }
}
</style>
